export default typeof window === `object` ? window.__threeDSettings : null;
